import React from "react";
import Navbar from "../components/navbar/Navbar";
import { BsFillPersonFill } from "react-icons/bs";
import DashboardItem from "../components/admin/DashboardItem";
import {
    BsMicrosoft,
    BsPersonLinesFill,
    BsPencilFill,
    BsFillFileBarGraphFill,
} from "react-icons/bs";
import { Outlet, Link } from "react-router-dom";

const AdminPanel = () => {
    return (
        <>
            <div className=" font['Body'] flex  h-auto  bg-[#1EA6D0] text-white">
                <div className='flex min-w-[17.5rem] flex-col bg-white px-4  py-4 text-black'>
                    <div className=' mt-8 flex flex-row'>
                        <BsFillPersonFill className=' mr-2 text-2xl text-main-600' />
                        <h4 className='text-xl text-gray-800'>Admin</h4>
                    </div>

                    <div>
                        <div className='font-med ml-4 mt-4'>Menu</div>
                        <div>
                            <DashboardItem icon={<BsMicrosoft />} type={"Dashboard"} path={""} />
                            <DashboardItem
                                icon={<BsPersonLinesFill />}
                                type={"Staff Management"}
                                path={"staff"}
                            />
                            <DashboardItem
                                icon={<BsPencilFill />}
                                type={"Item Management"}
                                path={"items"}
                            />
                            <DashboardItem
                                icon={<BsFillFileBarGraphFill />}
                                type={"Reports"}
                                path={"reports"}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </>
    );
};

export default AdminPanel;
